export function katakanaRule() {
    return function (input) {
        // eslint-disable-next-line no-irregular-whitespace
        return /^[ァ-ヶー 　ヷヸヹヺ]+$/.test(input) || "カタカナのみで入力してください";
    };
}
//# sourceMappingURL=katakana.js.map